
























interface IformData {
  fullName: string | null;
  newPassword: string | null;
  username: string | null;
}

import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import { resetUserPassword } from '@/utils/api';
import { randPassword } from '@/utils';

@Component({
  name: 'resetPasswordDialog',
  components: {},
})
export default class ResetPasswordDialog extends Vue {
  /*
   *@description:'向外暴露保存成功事件'
   */
  @Emit('success') submitSuccessEmit(msg?: any) {
    return msg;
  }
  dialogVisible: boolean = false;
  loading: boolean = false;
  formData: IformData = {
    fullName: '',
    username: null,
    newPassword: null,
  };
  /*
   *@description:'打开弹窗'
   */
  openDialog(rowData: { ['key']: any }): void {
    const newPassword = randPassword(8, 8);
    this.dialogVisible = true;
    this.$nextTick(() => {
      this.formData = {
        ...this.formData,
        ...rowData,
        newPassword: newPassword,
      };

      console.log('this.formData', this.formData);
    });
  }
  /*
   *@description:'确定'
   */
  submitForm() {
    this.loading = true;
    resetUserPassword(this.formData)
      .then((res) => {
        this.$message.success('重置密码成功');
        this.submitSuccessEmit();
        this.dialogVisible = false;
      })
      .catch((err) => {
        console.log('err:resetPasswordDialog', err);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  copySuccess() {
    this.$message.success('复制成功');
  }
  copyError() {
    this.$message.error('复制失败');
  }
}
